import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "../../routes";
import { useAuthContext } from "../../modules/Auth";
import { Button } from "../../components/Button";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import LogoSvg from "../../static/images/logo.svg";
import "./style.css";

export const LoginPage: FC = () => {
  const navigate = useNavigate();
  const { login, isInitializing, isAuthenticated } = useAuthContext();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(RoutePaths.root);
    }
  }, [isAuthenticated, navigate]);

  if (isInitializing) {
    return (
      <LoadingIndicator isLoading={isInitializing} size={120} center={true} />
    );
  }

  return (
    <div className="login-page">
      <img src={LogoSvg} alt="HCP Locator Logo" className="login-page-logo" />
      <h1 className="login-page-header">Tools</h1>
      <Button
        onClick={login}
        className="login-page-button"
        disabled={isInitializing}
      >
        Login
      </Button>
    </div>
  );
};
